import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ContactModel} from '@app/models/contact.model';
import {GtProducts} from '@app/models/enums/gt-products.enum';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {NameValueListType} from '@app/services/gt-configuration.service';
import {tap} from 'rxjs/operators';
import {EndUserNumber} from '@gt-api';
import {GtDirectoryService} from '@app/services/gt-directory.service';

@Component({
  selector: 'gt-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Output() back = new EventEmitter<void>();
  @Input() canEdit: boolean;
  contact: ContactModel;
  hasPolling = false;

  hasTrigging = false;
  hasInboundFeatures = false;
  products = GtProducts;
  nameValueListTypes = NameValueListType;

  constructor(
    private authenticationService: GtAuthenticationService,
    private directoryService: GtDirectoryService,
    public dialogRef: MatDialogRef<ProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: ContactModel
  ) {
    this.contact = dialogData;
  }

  ngOnInit() {
    if (this.contact) {
      this.hasTrigging = this.contact.hasTrigging();

      if (this.hasTrigging) {
        this.directoryService
          .getEndUserNumbers(this.contact.oname, this.contact.login)
          .pipe(tap((terminals: EndUserNumber[]) => (this.hasInboundFeatures = !terminals.some(t => t.trigging === 101))))
          .subscribe();
      }
    }

    if (this.authenticationService.oname !== this.contact.oname) {
      this.hasPolling = true;
    }
  }
}
